import { useMemo } from 'react';
import { createInterveneSx } from '../styles';
import useInterveneTheme from './useInterveneTheme';

/**
 * Theme-aware intervene layout styles — use instead of static interveneSx import.
 */
export default function useInterveneSx() {
  const { chat, status, typography, typographyStyles } = useInterveneTheme();

  return useMemo(
    () => createInterveneSx({ chat, status, typography, typographyStyles }),
    [chat, status, typography, typographyStyles]
  );
}
